






















import Vue from 'vue'
import moment from 'moment'

export default Vue.extend({
  data() {
    return {
      histories: [],
    }
  },
  props: {
    id: {
      required: true,
      type: Number,
    },
  },
  methods: {
    formatDate: (date: Date) => moment.utc(date).fromNow(),
    refresh: async function () {
      this.histories = await (
        await fetch(`/api/proposals/${this.id}/history`)
      ).json()
    },
  },
  mounted: async function () {
    this.histories = await (
      await fetch(`/api/proposals/${this.id}/history`)
    ).json()
  },

  name: 'ProposalHistory',
})
